import React from "react";
import { UserX } from "lucide-react";
import Button from "../ui/Button";

// current_plan comes back as a plan code ("pay_as_you_go") — humanize it
// rather than hardcoding a display name, since an admin can rename/introduce
// plans and the copy must not lie about which one the workspace is on.
function formatPlanName(planCode) {
  if (!planCode) return "a plan with fewer seats";
  const spaced = String(planCode).replace(/_/g, " ").trim();
  if (!spaced) return "a plan with fewer seats";
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

// Full-screen explanation for a member locked out because their workspace's
// plan now allows fewer seats than it has members. Only the owner keeps
// access, so this deliberately offers no self-serve upgrade path — just the
// explanation and a way out (sign out) for anyone in multiple workspaces.
export default function SeatLockedScreen({ currentPlan, seatLimit, onSignOut }) {
  const planName = formatPlanName(currentPlan);
  const hasSeatLimit = seatLimit !== null && seatLimit !== undefined;
  const seatCount = hasSeatLimit ? seatLimit : 1;
  const seatWord = seatCount === 1 ? "team member" : "team members";

  return (
    <div className="flex items-center justify-center min-h-svh p-4">
      <div className="flex flex-col items-center justify-center py-12 px-8 bg-card max-w-lg w-full rounded-2xl border border-border text-center">
        <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
          <UserX className="h-6 w-6" />
        </div>

        <h1 className="text-xl font-semibold text-foreground mb-3">
          Your seat was removed
        </h1>

        <p className="text-muted-foreground max-w-sm mb-8">
          This workspace moved to {planName}, which includes {seatCount}{" "}
          {seatWord}. Ask the workspace owner to upgrade to Growth to restore
          your access.
        </p>

        <Button variant="secondary" onClick={onSignOut}>
          Sign out
        </Button>
      </div>
    </div>
  );
}
